export enum EnumOAuthInteractionMode {
  Popup = 'popup',
  TopLevel = 'top_level',
}
